import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';
import { MarketplaceArche } from '@/lib/api';
import { archeIconUrl } from '@/lib/arche-icon-url';

interface ArcheSidebarItemProps {
  arche: MarketplaceArche;
  isActive: boolean;
}

export function ArcheSidebarItem({ arche, isActive }: ArcheSidebarItemProps) {
  return (
    <div
      className={`
        px-3 py-3 mx-2 min-h-[44px]
        border-b border-border last:border-b-0
        transition-colors duration-150
        ${isActive ? 'bg-primary/10 text-primary' : 'hover:bg-muted text-foreground'}
      `}
    >
      <Link to={`/a/${arche.archId}`} className="flex items-start gap-2.5">
        {arche.imageRef ? (
          <img
            src={archeIconUrl(arche.imageRef, 64) ?? ''}
            alt={arche.name}
            className="w-9 h-9 rounded-lg object-cover flex-shrink-0 shadow-sm"
          />
        ) : (
          <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 shadow-sm">
            <span className="text-sm font-semibold text-primary">{arche.name.charAt(0)}</span>
          </div>
        )}
        <div className="min-w-0 flex-1">
          <div className="font-medium text-sm line-clamp-2">{arche.name}</div>
          <div className="text-xs text-muted-foreground line-clamp-2 mt-0.5">
            {arche.simpleDescription}
          </div>
        </div>
      </Link>

      <Link
        to={`/marketplace/arches/${arche.archId}`}
        className="inline-flex items-center gap-1 mt-2 py-1 px-2 ml-[2.875rem] text-xs text-muted-foreground hover:text-foreground hover:bg-muted rounded transition-colors min-h-[32px]"
      >
        <Info className="h-3 w-3" />
        <span>Info</span>
      </Link>
    </div>
  );
}

export default ArcheSidebarItem;
